// shoppingcartActions.js


export const SET_ALL_CART_DATA = 'SET_ALL_CART_DATA';
export const SET_ALL_METACART_DATA = 'SET_ALL_METACART_DATA';
export const SET_METACART_ID_DATA = 'SET_METACART_ID_DATA';
export const SET_METACART_QUANTITY_DATA = 'SET_METACART_QUANTITY_DATA';
export const SET_METACART_TOTALPRICE_DATA = 'SET_METACART_TOTALPRICE_DATA';
export const SET_METACART_TOTALPRICEFORMAT_DATA = 'SET_METACART_TOTALPRICEFORMAT_DATA';
export const SET_IPSNOTICE_DATA = 'SET_IPSNOTICE_DATA';
export const SET_IPSPRODUCT_DATA = 'SET_IPSPRODUCT_DATA';

export const setAllCartData = (cartData) => ({
  type: SET_ALL_CART_DATA,
  payload: cartData
});

export const setAllMetacartData = (data) => ({
  type: SET_ALL_METACART_DATA,
  payload: data
});

export const setMetacartIdData = (id, idData) => ({
  type: SET_METACART_ID_DATA,
  payload: { id, idData }
});

export const setMetacartQuantityData = (id, quantityall) => ({
  type: SET_METACART_QUANTITY_DATA,
  payload: { id, quantityall }
});

export const setMetacartTotalPriceData = (id, totalprice) => ({
  type: SET_METACART_TOTALPRICE_DATA,
  payload: { id, totalprice }
});

export const setMetacartTotalPriceFormatData = (id, totalpriceformat) => ({
  type: SET_METACART_TOTALPRICEFORMAT_DATA,
  payload: { id, totalpriceformat }
});

export const setIPSNoticeData = (data) => ({
  type: SET_IPSNOTICE_DATA,
  payload: data
});

export const setIPSProductData = (data) => ({
  type: SET_IPSPRODUCT_DATA,
  payload: data
});